import { render, staticRenderFns } from "./UiMapCell.vue?vue&type=template&id=35252aa8&scoped=true&"
import script from "./UiMapCell.vue?vue&type=script&lang=ts&"
export * from "./UiMapCell.vue?vue&type=script&lang=ts&"
import style0 from "./UiMapCell.vue?vue&type=style&index=0&id=35252aa8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35252aa8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
